module.exports = __webpack_public_path__ + "static-portal/img/17-1.e72f331.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/17-1.jpg
// module id = EakT
// module chunks = 4